<script>
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import * as impersonation from "@shared/services/impersonation";

  const logout = async () => {
    await HttpPromise({ method: "DELETE", url: "/api/admin/users/stop_impersonating" });
    window.location.assign("/");
  };
</script>

<style>
  .impersonation-icon {
    margin-left: 1rem;
    margin-right: 0.3rem !important;
  }

  .logout {
    margin-left: 0.25rem;
  }
</style>

<div class="fizz-styles">
  {#if impersonation.isImpersonating()}
    <div class="fizz-surface-yellow fizz-flex-row fizz-inset-square-4 fizz-text-small">
      <span class="impersonation-icon">
        <Icon type="Eye" extraClassNames="fizz-icon-16" />
      </span>
      <p class="fizz-hide-on-small">
        <strong>{impersonation.trueUserName()}</strong> logged in as
        <strong>{impersonation.userName()}</strong>.
        <!-- svelte-ignore a11y-invalid-attribute -->
        <strong class="logout"><a href="#" on:click={logout}>Log Out</a></strong>
      </p>
      <p class="fizz-hide-on-large">
        <strong>{impersonation.userName()}</strong>
        <!-- svelte-ignore a11y-invalid-attribute -->
        <strong class="logout"><a href="#" on:click={logout}>Log Out</a></strong>
      </p>
    </div>
  {/if}
</div>
